import React, { useEffect, useRef } from 'react';

interface PerformanceMonitorProps {
  componentName: string;
  props?: any;
}

export const PerformanceMonitor: React.FC<PerformanceMonitorProps> = React.memo(({ componentName, props }) => {
  const renderCount = useRef(0);
  const lastRenderTime = useRef(Date.now());

  useEffect(() => {
    renderCount.current += 1;
    const now = Date.now();
    const timeSinceLastRender = now - lastRenderTime.current;
    lastRenderTime.current = now;

    if (process.env.NODE_ENV === 'development') {
      console.log(`🔄 ${componentName} re-rendered #${renderCount.current} (${timeSinceLastRender}ms since last render)`, {
        props: props ? Object.keys(props) : 'no props'
      });
    }
  });

  return null;
});

export default PerformanceMonitor; 